<template>
  <div
    ref="textarea"
    class="textarea"
    contenteditable="plaintext-only"
    spellcheck="false"
    :class="{'empty': isEmpty}"
    :placeholder="placeholder"
    @input="handleInput"
    @paste="handlePaste"
    @blur="handleBlur"
  >
  </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  name: 'com-textarea',
  components: {
  },
  props: {
    value: VueTypes.string.def(''),
    placeholder: VueTypes.string.def('')
  },
  data () {
    return {
      isEmpty: true
    }
  },
  watch: {
    value (val) {
      this.isEmpty = !val || val.length === 1 && this.$refs.textarea.innerText.match(/\n/) ? true : false

      if (this.isEmpty) {
        this.$refs.textarea.innerText = ''
      }

      this.$emit('empty', this.isEmpty)
    }
  },
  methods: {
    focus () {
      this.setTextAreaFocus(this.$refs.textarea)
    },
    handleInput ($event) {
      const text = $event.target.innerText
      this.isEmpty = !text.length
      this.$emit('input', text)
    },
    handlePaste ($event) {
      $event.preventDefault()
      // document.execCommand('insertText', false, $event.clipboardData.getData('text/plain'))
      let text = null
      let textRange = null
      let sel = null
      if (window.clipboardData && window.clipboardData.setData) {
        // IE
        text = window.clipboardData.getData('text')
      } else {
        text = ($event.originalEvent || $event.clipboardData).getData('text/plain')
      }

      if (document.body.createTextRange) {
        if (document.selection) {
          textRange = document.selection.createRange()
        } else if (window.getSelection) {
          sel = window.getSelection()
          let range = sel.getRangeAt(0)
          // 创建临时元素，使得TextRange可以移动到正确的位置
          let tempEl = document.createElement('span')
          tempEl.innerHTML = '&#FEFF;'
          range.deleteContents()
          range.insertNode(tempEl)
          textRange = document.body.createTextRange()
          textRange.moveToElementText(tempEl)
          tempEl.parentNode.removeChild(tempEl)
        }

        textRange.text = text
        textRange.collapse(false)
        textRange.select()
      } else {
        // Chrome之类浏览器
        document.execCommand('insertText', false, text)
      }
    },
    handleBlur ($event) {
      this.$emit('blur', $event)
    },
    /**
     * 让输入框获得焦点
     */
    setTextAreaFocus ($el) {
      if (window.getSelection) {
        $el.focus()
        let range = window.getSelection()
        range.selectAllChildren($el)
        range.collapseToEnd()
      } else if (document.selection) {
        let range = document.selection.createRange()
        range.moveToElementText($el)
        range.collapse(false)
        range.select()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/_common";
.textarea {
  position: relative;
  display: block;
  box-sizing: border-box;
  width: 100%; min-height: 36px;max-height: 130px;
  padding: 6px 15px;
  border: 1px solid #D8DEDF;
  border-radius: 4px;
  line-height: 24px;
  @include font(14, 400);
  resize: none; 
  @extend %transition;
  overflow-y: auto;
  -webkit-user-modify: read-write-plaintext-only;

  &:focus {
    border-color: #828a92;
  }

  &:empty:before {
    content: "\feff";
  }

  &.empty:after {
    content: attr(placeholder);
    position: absolute; top: 6px;
    font-weight: 500;
    color: $gray;
  }
}
</style>